import React from 'react';

function ThirdPartyExtensions() {
  return (
    <div
      dangerouslySetInnerHTML={{
        __html: `
            <esi:include src="/fragment/pdp-third-party-extensions-fe/third-party-content" />`,
      }}
    />
  );
}

export default ThirdPartyExtensions;
